import { IProdutoDafForm } from '../../../../../../modules/types/ProdutoDaf';

export const defaultProdutoDafFormMain: IProdutoDafForm = {
  id: 0,

  ////////////////////////////////////////
  // Chaves estrangeiras
  obmVmpId: 0,
  obmVmp: undefined,
  denominacaoGenericaId: 0,
  denominacaoGenerica: undefined,

  ////////////////////////////////////////
  // Classificações (códigos numéricos)
  aware: 0,
  formaFarmaceutica: 0,
  formaFarmaceuticaSimp: 0,
  umidade: 0,
  acondicionamento: 0,
  statusRename: 0,
  listaPaciente: 0,
  especializadoGrupo: 0,
  oncologicoGrupo: 0,

  ////////////////////////////////////////
  // Produto
  produtoFarmaceutico: '',
  concentracao: '',
  codigoAtc: '',

  ////////////////////////////////////////
  // Flags (S/N)
  oncologico: 0,
  biologico: 0,
  doencaRara: 0,
  statusDistribuicao: 0,

  compBasico: 0,
  compEspecializado: 0,
  compEstrategico: 0,
  compOncologico: 0,
  compRara: 0,

  usoHospitalar: 0,
  farmaciaPopular: 0,

  ////////////////////////////////////////
  // Rename
  dataRenamePublicacao: '',
  dataRenameAmpliacao: '',
  dataRenameExclusao: '',

  ////////////////////////////////////////
  // Observações
  regraValidacao: '',
  observacoes: '',

  // Tags
  tags: '',
  tagsArray: [],
};
